"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M2 22h20V2zm18-2H6.83L20 6.83z"
}), 'SignalCellular0BarTwoTone');